import { LogicalOperator } from "../LogicalOperations";
// TODO-rites: doplnit dokumentaci
export type AbstractClass<T> = Function & { prototype: T };
export type Class<T> = new (...params: any[]) => T;

export type OverridableType<T> = AbstractClass<T> | Class<T>; // TODO-rites: finalize a dokumentace

type SyncEvaluationFunction<TComponent, TBasicRightResult, TAllBasicRightsResult> = (component: TComponent, basicRightResult: TBasicRightResult, allBasicRightsResult: TAllBasicRightsResult) => boolean;

type AsyncEvaluationFunction<TComponent, TBasicRightResult, TAllBasicRightsResult> = (component: TComponent, basicRightResult: TBasicRightResult, allBasicRightsResult: TAllBasicRightsResult) => Promise<boolean>;

export type EvaluationFunctionType<TComponent, TBasicRightResult, TAllBasicRightsResult> = SyncEvaluationFunction<TComponent, TBasicRightResult, TAllBasicRightsResult> | AsyncEvaluationFunction<TComponent, TBasicRightResult, TAllBasicRightsResult>;

/**
 * Umožňuje upravovat výsledek vyhodnocení práv pro různé objekty, nad kterými se práva vyhodnocují
 * @includeToDoc
 */
export interface IRightsEvaluationOverrides<TRightType, TComponent, TBasicRightResult, TAllBasicRightsResult> {
    /**
     * Zda se nad daným typem nemají vyhodnocovat práva
     * @param typeIdentifier Kontrolovaný typ
     */
    isIgnored<TComponentType>(typeIdentifier: OverridableType<TComponentType>): boolean;

    /**
     * Vrací logický operátor, který se má použít pro předaný typ práva mezi jednotlivými override funkcemi nad jednou komponentou
     * @param rightType Typ práva, pro který chceme vrátit operátor
     */
    getOperatorForRightType(rightType: TRightType): LogicalOperator | null;

    /**
     * Vrátí kolekci funkcí, které upravují výsledek vyhodnocení práva nad daným typem
     * @param typeIdentifier Kontrolovaný typ
     */
    getOverridesForComponent(controlWrapper: TComponent): IRightTypeEvaluationFunction<TRightType, TComponent, TBasicRightResult, TAllBasicRightsResult>[];
}

/**
 * Funkce, která upravuje výsledek vyhodnocení práva
 * @includeToDoc
 */
export interface IRightTypeEvaluationFunction<TRightType, TComponent, TBasicRightResult, TAllBasicRightsResult> {
    /** Type vyhodnocovaného práva */
    rightType: TRightType;
    /** Funkce, která upravuje výsledek vyhodnocení práva nad předaným prvkem */
    evaluationFunction: EvaluationFunctionType<TComponent, TBasicRightResult, TAllBasicRightsResult>;
}

/**
 * Informace o typu, pro který lze registrovat override funkce
 * @includeToDoc
 */
export interface IOverridableTypeInfo {
    /**
     * Registrovaný typ
     */
    overrideType: OverridableType<any>;
    /**
     * Příznak, zda je tento typ interface
     */
    isInterface?: boolean;
}
